<script lang="ts" setup></script>

<template>
  <div class="separator">
    <hr>
  </div>
</template>

<style lang="scss" scoped>
@use 'CardSeparator';
</style>
